import { IBorderRadiusData } from "./border-data";
import { IPxHeightData } from "./height-data";
import { IWidgetVisibility, SelfPosition, VisibilityData, WidgetPlaceType } from "./index";
import { IElementWithLink, LinkData } from "./link-data";
import { IPositionData } from "./position-data";
import { IAnimatedWidget } from "./widget-style-data";

export interface ILogoWidgetData extends IElementWithLink, IWidgetVisibility {
    readonly type: "LogoWidget";
    placeType: WidgetPlaceType;
    id?: string | null;
    preferredLogoId?: string | null;
    altText: string;
    style: ILogoWidgetStyle | null;
}

export interface ILogoWidgetStyle extends IAnimatedWidget {
    heightData?: IPxHeightData | null;
    logoStyle?: ILogoStyle | null;
}

export interface ILogoStyle {
    borderRadius?: IBorderRadiusData | null;
    position?: IPositionData | null;
    thickness?: string | null;
    borderColor?: string | null;
    logoAlignment?: SelfPosition | null;
}

export abstract class LogoWidgetData {

    public static updateWithDefaults(data: ILogoWidgetData): void {
        data.preferredLogoId = this.defaultData.preferredLogoId;
        data.style = this.defaultData.style;
        data.visibility = this.defaultData.visibility;
        data.linkData = this.defaultData.linkData;
        data.altText = this.defaultData.altText;
    }

    public static get defaultData(): ILogoWidgetData {
        return {
            type: "LogoWidget",
            placeType: "Section",
            preferredLogoId: null,
            altText: "Company Logo",
            style: this.defaultStyle,
            linkData: LinkData.noneData,
            visibility: VisibilityData.defaultData()
        };
    }

    public static get defaultStyle(): ILogoWidgetStyle {
        return {
            heightData: {
                height: 40
            },
            logoStyle: {
                borderRadius: {
                    topLeftPx: 0,
                    topRightPx: 0,
                    bottomLeftPx: 0,
                    bottomRightPx: 0
                },
                logoAlignment: "center",
                thickness: "0",
                borderColor: "#D2D2D5"
            },
            animation: {
                animationSource: "site-design",
                animationData: {
                    name: "none",
                    duration: 1
                }
            }
        };
    }

}
